import React, { Component } from 'react';
import { graphql } from 'gatsby';
import {
  Layout,
  Wrapper,
  PostcardForm,
} from '../components';
import {
  AboutTextCol,
  AboutPhotoCol,
  AboutMobilePhotoSlider,
  AboutMobilePortrait,
} from '../components/About';
import './about.scss';

const isClient = typeof window !== 'undefined';
const MOBILE_BREAKPOINT = 1080;

class AboutPage extends Component {
  state = {
    viewportWidth: 0,
  };

  componentDidMount() {
    if (isClient) {
      this.updateWindowDimensions();
      window.addEventListener('resize', this.updateWindowDimensions);
    }
  }

  componentWillUnmount() {
    if (isClient) window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ viewportWidth: window.innerWidth });
  }

  render() {
    const {
      data: {
        page: {
          data: pageData,
        },
      },
      location,
    } = this.props;
    const {
      viewportWidth,
    } = this.state;
    const isMobile = Boolean(viewportWidth <= MOBILE_BREAKPOINT);
    const {
      metaTitle,
      metaDescription,
      openGraphImage,
    } = pageData;
    const seoData = {
      metaTitle,
      metaDescription,
      openGraphImage,
    };
    return (
      <Layout location={location} seoData={seoData}>
        <Wrapper>
          <div className="about-container">
            {isMobile && (
              <AboutMobilePortrait
                {...pageData}
              />
            )}
            {!isMobile && (
              <AboutPhotoCol
                {...pageData}
              />
            )}
            <AboutTextCol
              isMobile={isMobile}
              {...pageData}
            />
          </div>
        </Wrapper>
        {isMobile && (
          <AboutMobilePhotoSlider
            {...pageData}
          />
        )}
        <PostcardForm
          title="Get in touch"
          formName="contact-form-about"
        />
      </Layout>
    );
  }
}

export default AboutPage;

export const pageQuery = graphql`
query AboutPageQuery {
  site {
    siteMetadata {
      storiesSlug,
    }
  },
  page: prismicAbout {
    uid,
    data {
      personalPortrait: personal_portrait {
        alt
        localFile {
          childImageSharp {
            fluid(maxWidth: 1000, quality: 90) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
      portraitTimestamp: portrait_timestamp(formatString: "DD MMM YYYY")
      portraitCaption: portrait_caption {
        html
        text
      }
      aboutTitle: about_title {
        html
        text
      }
      biography {
        html
        text
      }
      approachTitle: approach_title {
        html
        text
      }
      approachDescription: approach_description {
        html
        text
      }
      photographyShowcase: photography_showcase {
        featuredPhoto: featured_photo {
          alt
          localFile {
            id
            childImageSharp {
              fluid(maxWidth: 1000, quality: 90) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
        photoOrientation: photo_orientation
        caption {
          html
          text
        }
      }
      metaTitle: meta_title {
        html
        text
      },
      metaDescription: meta_description {
        html
        text
      },
      openGraphImage: open_graph_image {
        alt
        copyright
        url
      }
    }
  }
}
`;
